import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { Const, ResourceType } from '../../../../core/helpers/Const';
import {firstValueFrom, Observable} from 'rxjs';
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {
    MoveFailedErrorMessageDialogComponent
} from "../move-failed-error-message-dialog/move-failed-error-message-dialog.component";
import {DialogService} from "../../../../service/services/misc/dialog/dialog.service";
import {ResourceDataService} from "../../../../service/services/rest/resource-data/resource-data.service";
import {nil} from "ajv";

@Component({
    selector: 'app-move-resource-confirmation-dialog',
    templateUrl: './move-resource-confirmation-dialog.component.html',
    styleUrls: ['./move-resource-confirmation-dialog.component.scss'],
    standalone: false
})
export class MoveResourceConfirmationDialogComponent implements OnInit {
    resource: ResourceModel;
    headerIcon: IconProp;
    msg: string;
    title: string;
    errorMsg: string;
    targetResourcePath: string;
    targetResourceName: string;

    Const = Const;
    loading = false;

    constructor(
        public dialogRef: DialogRef,
        public dialogService: DialogService,
        public resourceDataService: ResourceDataService) {}

    ngOnInit(): void {
        let data = this.dialogRef.data;
        this.resource = data.resource;
        const typeName = this.resource?.typeDisplayName || this.resource?.type;
        this.title = `Move ${typeName}`;
        this.targetResourcePath = data.targetResourcePath;
        this.targetResourceName = data.targetResourceName;
        this.msg = this.getConfirmationMessage(this.resource.displayName, typeName, this.resource.path, this.targetResourceName, this.targetResourcePath);
    }

    async onMove() {
        this.loading = true;
        this.dialogRef.loading(true);
        let moveOperationPreflightResult = {
            resource: this.resource,
            preflightSucceeded: false,
            msg: "",
            errorMsg: "",
            retryFunc: this.moveFunc.bind(this)
        };
        try {
            await firstValueFrom(this.moveFunc());
            moveOperationPreflightResult.preflightSucceeded = true;
        } catch (err: any) {
            moveOperationPreflightResult.errorMsg = err.message;
            moveOperationPreflightResult.msg = "We encountered a problem while preparing to move the resource to its new location.";
        } finally {
            this.loading = false;
            this.dialogRef.loading(false);
            this.dialogRef.close(moveOperationPreflightResult);
        }
    }

    moveFunc(): Observable<any> {
        return this.resourceDataService.move(this.resource.apiVersion, this.resource.type, this.resource.path, this.resource.name, {destination: `${this.targetResourcePath}/${this.targetResourceName}`});
    }

    validate() {
        return !this.loading;
    }

    getConfirmationMessage(displayName: string, resourceType: string, currentPath: string, targetResourceName: string, targetPath: string) {
        const folderOrResourceGroup = (resourceType === ResourceType.FOLDER || resourceType === Const.RESOURCE_TYPE_DISPLAY_NAMES[ResourceType.FOLDER]) || (resourceType === ResourceType.RESOURCE_GROUP || resourceType === Const.RESOURCE_TYPE_DISPLAY_NAMES[ResourceType.RESOURCE_GROUP]);
        if (folderOrResourceGroup) {
            return `Are you sure you want to move '${displayName}' (${resourceType}) and its contents from ${currentPath} to '${targetResourceName}' (Folder) in path ${targetPath}?`;
        } else {
            return `Are you sure you want to move '${displayName}' (${resourceType}) from ${currentPath} to '${targetResourceName}' in path ${targetPath}?`;
        }
    }
}
